module.exports = __webpack_public_path__ + "img/node_button_normal@2x.cb964df0.png";